import { z } from 'zod';

import { TextItem } from './common';

export const WarningSign = TextItem;
export const WarningSigns = z.array(WarningSign).default([]);

export type WarningSign = z.infer<typeof WarningSign>;
export type WarningSigns = z.infer<typeof WarningSigns>;
